import React from "react";

import { useHistory } from "react-router";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
// import Typography from "@material-ui/core/Typography";
// import IconButton from "@material-ui/core/IconButton";
// import Tooltip from "@material-ui/core/Tooltip";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import Switch from "@material-ui/core/Switch";
// import FilterListIcon from "@material-ui/icons/FilterList";

import { SERVER_URI } from "../../constants";

import ValueCell from "./value-cell";

interface Props {
  // nodes?: any[];
  // // panelId?: string;
  // panelName: String;
  // startDate: number; // Date;
  // endDate: number; // Date;
  // widgetStatic?: boolean;
  // widgetTitle?: string;
  metaData: any;
  style?: React.CSSProperties;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    linkCell: {
      cursor: "pointer",
      textDecoration: "underline",
    },
  })
);

// TODO rename, e.g., LiveDataTable, used both for panels, panel collections (list overview)
function PanelTable(props: Props) {
  const {
    // nodes,
    // // panelId,
    // panelName,
    // startDate,
    // endDate,
    // widgetStatic,
    // widgetTitle,
    metaData,
    style,
  } = props;
  const classes = useStyles(props);
  // console.log("table meta", metaData);
  // const { panelCollectionName } = useParams<any>();
  const history = useHistory();
  return (
    <TableContainer style={style}>
      <Table
        // className={classes.table}
        // aria-labelledby="tableTitle"
        // size={dense ? 'small' : 'medium'}
        size={"small"}
        // aria-label="enhanced table"
      >
        <TableHead>
          <TableRow>
            {/* <TableCell
        // padding="checkbox"
        >
        </TableCell> */}
            {metaData.columns.map((headCell: any) => (
              <TableCell
                key={headCell.number}
                // align={headCell.numeric ? 'right' : 'left'}
                // padding={headCell.disablePadding ? 'none' : 'default'}
                // sortDirection={orderBy === headCell.id ? order : false}
                align="center"
              >
                <TableSortLabel
                // active={orderBy === headCell.id}
                // direction={orderBy === headCell.id ? order : 'asc'}
                // onClick={createSortHandler(headCell.id)}
                >
                  {headCell.headerData.content}
                  {/* {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null} */}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {metaData.rowData.map((row: any, rowIndex: number) => {
            // const isItemSelected = isSelected(row.name);
            // const labelId = `enhanced-table-checkbox-${index}`;

            return (
              <TableRow
                hover
                // onClick={(event) => handleClick(event, row.name)}
                // role="checkbox"
                // aria-checked={isItemSelected}
                // tabIndex={-1}
                // key={row.name}
                // selected={isItemSelected}
                key={rowIndex}
              >
                {row.map((cell: any, cellIndex: number) => (
                  <TableCell
                    style={{ height: "40px" }} // TODO remove once frozen columns are implemented
                    align={
                      !cell.ajaxUrl || cell.ajaxUrl === "" ? "left" : "right"
                    } // TODO implement correctly!
                    key={cellIndex}
                    className={cell.hasLink ? classes.linkCell : undefined}
                    onClick={(evt) => {
                      if (cell.hasLink) {
                        let searchParams = new URL(cell.link).searchParams;
                        const template = searchParams.get("template");
                        // const tab = searchParams.get("tab");
                        // const node = searchParams.get("node");
                        history.push(
                          `/livedata/collections/${template}/panel${
                            new URL(cell.link).search
                          }`
                          // `/livedata/collections/${template}/panel?node=${node}`
                        );
                      }
                    }}
                  >
                    {cell.ajaxUrl ? (
                      <ValueCell metaData={cell} />
                    ) : !!cell.hasImage ? (
                      <div>
                        <img
                          src={`${SERVER_URI}${cell.image}`}
                          title={cell.title}
                          alt={cell.title}
                        />
                        &nbsp;{cell.content}
                      </div>
                    ) : (
                      <div>{cell.content}</div>
                    )}
                  </TableCell>
                ))}
                {/* <TableCell padding="checkbox">
                  <Checkbox
                    checked={isItemSelected}
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </TableCell>
                <TableCell component="th" id={labelId} scope="row" padding="none">
                  {row.name}
                </TableCell>
                <TableCell align="right">{row.calories}</TableCell>
                <TableCell align="right">{row.fat}</TableCell>
                <TableCell align="right">{row.carbs}</TableCell>
                <TableCell align="right">{row.protein}</TableCell> */}
              </TableRow>
            );
          })}
          {/* {emptyRows > 0 && (
          <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
            <TableCell colSpan={6} />
          </TableRow>
        )} */}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default PanelTable;
